import { Component, OnInit } from '@angular/core';
import { Subject, takeUntil } from "rxjs";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { InventoryService } from "../../../services/inventory/inventory.service";
import { SupplierOrderDetailsModel } from "../../../models/suppliers/supplier-order-details.model";
import { AuthenticationService } from "../../../../share-modul/services/authentication/authentication.service";
import { MenuService } from "../../../services/menus/menu.service";
import { UserModel } from "../../../../share-modul/models/user/user.model";

@Component({
  selector: 'app-supplier-order-details',
  templateUrl: './supplier-order-details.component.html',
  styleUrls: ['./supplier-order-details.component.scss']
})
export class SupplierOrderDetailsComponent implements OnInit {

  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>();
  public ordersDetailsList: Array<SupplierOrderDetailsModel> = [];
  public spinner: boolean = false;
  public supplierName: string;
  public venueId : string | null;
  public currency: string;
  public user: UserModel;
  //#endregion

  //#region Constructor
  constructor(
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private inventoryService: InventoryService,
    private authService: AuthenticationService,
    private menuService: MenuService
  ) {
    if (this.config.data != undefined && this.config.data.name && this.config.data.venueId) {
      this.supplierName = this.config.data.name;
      this.venueId = this.config.data.venueId;
    }
  }

  ngOnInit(): void {
    this.authService.loginUser.subscribe(user => {
      this.user = user!;
      this.getDefaultCurrency();
    });
    this.getOrdersDetailsBySupplier();
  }
  //#endregion

  //#region Public Methods
  getOrdersDetailsBySupplier(): void {
    this.inventoryService.loadSupplierOrdersDetails(this.supplierName,this.venueId!)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.spinner = false;
          response.forEach((invoiceObject: any) => {
            invoiceObject.supplies.forEach((supply: any) => {
              const object = new SupplierOrderDetailsModel();
              object.invoiceId = invoiceObject.invoiceNumber;
              object.supplyName = supply.supplyName;
              object.date = supply.date;
              object.quantity = supply.quantity;
              object.grossPrice = supply.grossPrice;
              object.unitOfMeasurementShortName = supply.unitOfMeasurementShortName;
              this.ordersDetailsList = [...this.ordersDetailsList, object];
            });
          });
        },
        error: errorResponse => {
          this.spinner = false;
        }
      });
  }

  public getDefaultCurrency(): void {
    let companyId = this.authService.getCompanyId();
    this.menuService.getDefaultCurrency(companyId, this.user.roles)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.currency = response.symbol;
        }
      });
  }
  //#endregion

}
